module.exports = __webpack_public_path__ + "static/media/meta.f56f654c.svg";